import styled from 'styled-components';
import { IThemeProvider } from '../../../../../styles/theme';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  margin: 0.8rem 0 2rem 0;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 20px;
  `}
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Header = styled.div`
  font-size: 20px;
  line-height: 23px;
  /* text-transform: capitalize; */
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;

export const Legend = styled.div`
  margin-top: 16px;
`;

export const FlexBlock = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const Text = styled.span<IThemeProvider>`
  font-weight: 400;
  font-size: 12px;
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[60]};
  `}
`;
